
import axios from "axios";

import { IP } from "utils/Host";

// zmiana procesora w grupie z poziomu technologia stage
export function dropStageZmienCzasTrwaniaGold(targetId,newEndDate,refreshGantAll) {

// id = procesor id
  
  axios
  .get(IP + "API_0017_gant_procedura_zmien_czas_trwania_gold/"+targetId+"/"+newEndDate+"/" + sessionStorage.getItem("token"))
    .then((res) => {
refreshGantAll()

    })
}

//   +"/" + sessionStorage.getItem("token")

